import Button from "../../Button";
import InterviewBody from "./InterviewBody";
import Profile from "../Home/LandingPage/Profile";
import BackSvgIcon from "../../../Svg/BackSvgIcon";
import React, { useEffect, useContext, useState } from "react";
import AlertContext from "../../../context/AlertContext";
import { useVoiceVisualizer } from "react-voice-visualizer";
import InterviewHooks from "../../../Hooks/AI/InterviewHooks";
import WarningSvg from "../../Notification-Loading/Notify/Svg/WarningSvg";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import { StudentTestPageContext } from "../../../context/StudentTestPageContext";
import CodingHeaderLearnerSideHooks from "../../../Hooks/CodingPage/CodingHeaderLearnerSideHooks";
import useS3FileManagement from "../../../Hooks/useS3FileManagement";
import constants from "../../../constants";

export default function Interview() {
  const Alert = useContext(AlertContext);
  const StudentTestPageCxt = useContext(StudentTestPageContext);

  const InterviewHks = InterviewHooks();
  const { getPreSignedUrl } = useS3FileManagement();
  const recorderControls = useVoiceVisualizer();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const { submitAnswers } = CodingHeaderLearnerSideHooks();
  const [s3Url, setS3Url] = useState([]);
  const [questionIndex, setQuestionIndex] = useState(null);

  const { stopRecording } = recorderControls;

  useEffect(() => {
    if (StudentTestPageCxt.showButton.testAuto) {
      InterviewHks.playQns(
        `You were unable to complete the test within the given time. We will submit your response. You have successfully completed the
        AI interview. We will notify you of the results after evaluation.`
      );
    } else if (StudentTestPageCxt.showButton.currentQnsAuto) {
      if (StudentTestPageCxt.showButton.last) {
        InterviewHks.playQns(
          `You were unable to answer this question within the given time. We will submit your response. You have successfully completed the
          AI interview. We will notify you of the results after evaluation.`
        );
      } else {
        InterviewHks.playQns(
          `You were unable to answer this question within the given time. We will submit your response for this question. You can proceed to
        the next one.`
        );
      }
    } else if (
      StudentTestPageCxt.showButton.next &&
      !StudentTestPageCxt.showButton.view
    ) {
      InterviewHks.playQns({
        name: "Thank you for your response, let's proceed to the next question",
      });
    } else if (
      StudentTestPageCxt.showButton.last &&
      !StudentTestPageCxt.showButton.view
    ) {
      InterviewHks.playQns(
        `Thank you for your response! You have successfully completed the AI interview. We will notify you of the results after
      evaluation.`
      );
    }
  }, [StudentTestPageCxt.showButton]);

  useEffect(() => {
    const handleTestTimeLimit = setInterval(() => {
      if (Alert.comingObj.duration === 0) {
        StudentTestPageCxt.recognitionRef.current = "testAuto";
        stopRecording();
        submitAnswers(null, true, "interview", "actionType");
        clearInterval(handleTestTimeLimit);
      } else {
        Alert.updateComingObj((prev) => ({
          ...prev,
          duration: prev.duration - 1,
        }));
      }
    }, 1000);

    return () => {
      clearInterval(handleTestTimeLimit);
    };
  }, [Alert.comingObj.duration]);

  useEffect(() => {
    if (Alert.isAdmin || Alert.testData.status == constants.QUESTION_STATUS.SUBMITTED) {
      getPresignedUrlFunction();
    }
  }, []);

  const getPresignedUrlFunction = async () => {
    try {
      let fileArr = [];
      let fileTypeArr = [];
      for (let section of Alert.comingObj.sections) {
        for (let question of section.questions) {
          if (question.answer) {
            fileArr.push(question.answer);
            fileTypeArr.push(question.answer.split(".").pop());
          }
        }
      }
      let urlArr = await getPreSignedUrl(
        fileArr,
        undefined,
        fileTypeArr,
        "GET"
      );
      if (urlArr.resultCode === constants.RESULT_STATUS.SUCCESS) {
        setS3Url(urlArr.url);
        let count = 0;
        for (let section of Alert.comingObj.sections) {
          for (let question of section.questions) {
            question.preSignedUrl = urlArr.url[count];
            count++;
          }
        }
      }
      else {
        throw new Error("Something went wrong while getting the presigned Url");
      }
      console.log("Alert.commmmmmm:", Alert.comingObj, "Object.keys(Alert.comingObj).length:", Object.keys(Alert.comingObj).length);
      console.log("urlArr", urlArr);
    } catch (error) {
      console.log("Error:", error);
      useCommonFunctionHks.getCatchBlockDetails();
    }
  }

  return (
    Object.keys(Alert.comingObj).length !== 0 && (
      <div className="interviewMainContainer">
        <BackSvgIcon
          component="interview"
          onClick={() =>
            InterviewHks.handleBack({
              from: "back",
              stopAudioRecording: stopRecording,
            })
          }
        />
        <div className="interviewTestName">{Alert.comingObj.testname}</div>
        <div className="interviewInnerMainContainer">
          <div className="interviewBody" ref={InterviewHks.containerRef}>
            <div className="interviewBodyHeader">
              <div className="interviewBodyHeaderQuestionNo">
                Question {StudentTestPageCxt.currentQnIndex + 1}/
                {Alert.comingObj.sections[0].questions.length}
              </div>
              {!StudentTestPageCxt.currentQnData.hasOwnProperty(
                "actualscore"
              ) && (
                  <div className="interviewBodyHeaderCurrentQnTime">
                    Time Left :
                    <span className="interviewBodyHeaderCurrentQnTimeCounter">
                      {useCommonFunctionHks.formatTime(
                        StudentTestPageCxt.currentQnData.qnduration
                      )}
                    </span>
                  </div>
                )}
            </div>
            <InterviewBody />
            {(StudentTestPageCxt.showButton.next ||
              StudentTestPageCxt.showButton.last) && (
                <div
                  className={`interviewBodyFooter ${StudentTestPageCxt.currentQnIndex > 0 &&
                    StudentTestPageCxt.currentQnData.hasOwnProperty("actualscore")
                    ? ""
                    : "end"
                    }`}
                >
                  {StudentTestPageCxt.currentQnIndex > 0 &&
                    StudentTestPageCxt.currentQnData.hasOwnProperty(
                      "actualscore"
                    ) && (
                      <Button
                        size="sm"
                        disable={Alert.buttonDisable}
                        onClick={InterviewHks.handlePrevious}
                        hierarchy={{
                          type: "secondaryGrey",
                          buttonText: "Previous",
                        }}
                      />
                    )}
                  {((StudentTestPageCxt.showButton.next &&
                    StudentTestPageCxt.currentQnIndex <
                    Alert.comingObj.sections[0].questions.length - 1) ||
                    StudentTestPageCxt.showButton.last) &&
                    StudentTestPageCxt.currentQnIndex <
                    Alert.comingObj.sections[0].questions.length && (
                      <Button
                        size="sm"
                        disable={Alert.buttonDisable}
                        onClick={
                          StudentTestPageCxt.showButton.next
                            ? InterviewHks.handleNext
                            : StudentTestPageCxt.showButton.last
                              ? InterviewHks.handleBack
                              : () => stopRecording()
                        }
                        hierarchy={{
                          type: "primary",
                          buttonText: StudentTestPageCxt.showButton.next
                            ? "Next"
                            : StudentTestPageCxt.showButton.last
                              ? "Finish"
                              : "Submit",
                        }}
                      />
                    )}
                </div>
              )}
          </div>
          <div className="interviewRightDiv">
            {StudentTestPageCxt.currentQnData.answer ? (
              <video
                controls
                className="interviewCam"
                ref={StudentTestPageCxt.videoRef}
                src={StudentTestPageCxt.currentQnData.preSignedUrl ?? StudentTestPageCxt.currentQnData.answer}
                autoPlay={!StudentTestPageCxt.showButton.view}
              />
            ) : (
              <video
                autoPlay
                ref={StudentTestPageCxt.videoRef}
                className={`interviewCam ${Alert.comingObj?.data?.deducted ? "warn" : ""
                  }`}
              />
            )}
            {Alert.comingObj?.data?.deducted &&
              !StudentTestPageCxt.currentQnData.hasOwnProperty(
                "actualscore"
              ) && (
                <div className="interviewMultiFaceDeducted">
                  <div className="interviewMultiFaceDeductedHeader">
                    <WarningSvg component="interview" />
                    {Alert.comingObj?.data.Multi_People_Found
                      ? "Multiple Individuals Detected"
                      : "Face Not Found"}
                  </div>
                  <div className="interviewMultiFaceDeductedBody">
                    {Alert.comingObj?.data.Multi_People_Found
                      ? "Multiple individuals detected. Please ensure you are alone to continue the interview."
                      : "Your face is not visible in the camera. Please ensure you are within the camera frame to continue the interview."}
                  </div>
                </div>
              )}
          </div>
        </div>

        {Alert.isTakeTest &&
          Alert.comingObj.videoqn === 1 &&
          !StudentTestPageCxt.showButton.view && !StudentTestPageCxt.showButton.next && !StudentTestPageCxt.showButton.last && (
            <Profile type="verfypic" isTakeTest={Alert.isTakeTest} />
          )}
      </div>
    )
  );
}
